import hosts from './common/hosts';
/**
 * 会根据不同参数，生成不同的API接口
 * 使用：
 * const api=Serices.createApi();
 * api.getCountryList().then((data) => {
 *   console.log('APICommon == getCountryList', data);
 *  });
 */
function getAlias() {
    if (window.baseAxios) {
        return window.baseAxios.alias;
    } else {
        return 'liveme';
    }
}
const Services = {
    /**
     * 获取 Api APICommon 接口
     */
    createApi() {
        return new window.APICommon(window.KEWLHttp, { ...hosts.getBase() }, getAlias());
    }
};

export default Services;
